import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';

import cls from 'classnames/bind';

import FormattedDate from '@ott/formatted-date';
import FormattedPeriod from '@ott/formatted-period';
import { getLayoutContextValue } from '@ott/layout-context';
import KM from '@ott/utility-km';

import Cookie from 'js-cookie';

import s from './SearchHistory.scss';

const cx = cls.bind(s);

const LEFT_MOUSE_BUTTON = 0;

class SearchHistory extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    handleSearch: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        from: PropTypes.string,
        to: PropTypes.string,
        fromDate: PropTypes.instanceOf(Date),
        toDate: PropTypes.instanceOf(Date),
        isRT: PropTypes.bool,
        isMW: PropTypes.bool,
        url: PropTypes.string,
        /** для isMW */
        directions: PropTypes.arrayOf(
          PropTypes.shape({
            from: PropTypes.string,
            to: PropTypes.string,
            date: PropTypes.instanceOf(Date),
          })
        ),
        /** опционально, полезно передавать инфу для handleSearch */
        data: PropTypes.any,
        onOpen: PropTypes.func,
      })
    ),
    /** avia, railways, ..., для статистики KM */
    project: PropTypes.string.isRequired,
    page: PropTypes.string,
    foldSameDate: PropTypes.bool,
    itemsHaveLimitedWidth: PropTypes.bool,
  };

  static defaultProps = {
    foldSameDate: false,
    itemsHaveLimitedWidth: false,
  };

  componentDidMount() {
    const { onOpen = null } = this.props;
    if (onOpen) {
      onOpen();
    }
  }

  renderDateString(route) {
    const { foldSameDate } = this.props;

    const fromDate = route.fromDate ? new Date(route.fromDate) : null;

    if (!fromDate) {
      return null;
    }

    if (route.isRT && route.toDate) {
      const toDate = new Date(route.toDate);

      return (
        <FormattedPeriod
          className={cx('searchItem--date')}
          startDate={fromDate}
          endDate={toDate}
          isShortMonth={true}
          showYear={true}
          foldSameDate={foldSameDate}
        />
      );
    }

    return <FormattedDate className={cx('searchItem--date')} date={fromDate} isShortMonth />;
  }

  renderRouteNode(route, key) {
    const { itemsHaveLimitedWidth } = this.props;

    if (route.isMW) {
      return route.directions.map((dir, index) => {
        const date = new Date(dir.date);
        const isLast = index + 1 === route.directions.length;
        return (
          <div
            className={cx('searchItem--wrap', {
              itemsHaveLimitedWidth,
            })}
            key={`${key}_${index}`}
          >
            <span className={cx('searchItem--city')}>{dir.from}</span>
            <span>&nbsp;&mdash;&nbsp;</span>
            <span className={cx('searchItem--city')}>{dir.to}</span>
            <FormattedDate date={date} isShortMonth={true} className={cx('searchItem--date')} />
            <span>;</span>
            {!isLast && <span>&nbsp;</span>}
          </div>
        );
      });
    }

    return (
      <div
        className={cx('searchItem--wrap', {
          itemsHaveLimitedWidth,
        })}
        key={key}
      >
        <span className={cx('searchItem--city')}>{route.from}</span>

        {Boolean(route.to) && (
          <Fragment>
            &nbsp;&mdash;&nbsp;
            <span className={cx('searchItem--city')}>{route.to}</span>
          </Fragment>
        )}

        {this.renderDateString(route)}
      </div>
    );
  }

  handleClick(e, routeSearch) {
    const { handleSearch, project, page } = this.props;

    KM('search_history', {
      obj: {
        timestamp: Date.now(),
        referrer: Cookie.get('referrer') || '',
        vid: Cookie.get('vid') || '',
        project,
        page,
        isMobile: getLayoutContextValue().isMobile,
      },
    });

    if ((e.metaKey || e.ctrlKey) && e.button === LEFT_MOUSE_BUTTON) {
      return;
    }

    e.preventDefault();
    handleSearch(routeSearch);
  }

  getSearchRoutesNode = (searchHistoryRoutes) => {
    const { childrenClassNames = {} } = this.props;
    if (!searchHistoryRoutes || searchHistoryRoutes.length === 0) {
      return;
    }

    return searchHistoryRoutes.map((searchRoute, index) => (
      <div
        key={index}
        className={cx('searchItem', childrenClassNames.searchItem, {
          'searchItem--isMW': searchRoute.isMW,
        })}
        data-locator="searchItem"
      >
        <a
          href={searchRoute.url}
          className={cx('searchItem--link')}
          onClick={(e) => this.handleClick(e, searchRoute)}
          draggable={false}
        >
          {this.renderRouteNode(searchRoute, index)}
        </a>
      </div>
    ));
  };

  render() {
    const { items, className } = this.props;
    const searchRoutesNode = this.getSearchRoutesNode(items);
    return <div className={cx('searchHistory', className)}>{searchRoutesNode}</div>;
  }
}

export default SearchHistory;
export {
  saveSearchRouteInLocalStorage,
  getRoutesFromLocalStorage,
  checkSearchHistoryFromStorage,
} from './helpers/searchHistoryLocalStorage';
